import { useEffect, useState } from 'react'
import { SCREEN_SIZE } from '../constants/common'

const getIsMobile = (breakpoint) => {
  if (typeof window === 'undefined') return false
  return window.innerWidth < breakpoint
}

const useIsMobile = (breakpoint = SCREEN_SIZE.MOBILE) => {
  const [isMobile, setIsMobile] = useState(() => getIsMobile(breakpoint))

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile(breakpoint))
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isMobile
}

export default useIsMobile
